/**
 * Copyright 2025 Beijing Volcano Engine Technology Co., Ltd. All Rights Reserved.
 * SPDX-license-identifier: BSD-3-Clause
 */

/**
 * @brief Basic APIs
 */
export const BasicAPIs = [
  {
    action: 'getScenes',
    apiPath: '/getScenes',
    method: 'post',
  },
] as const;

/**
 * @brief Basic APIs
 */
export const AigcAPIs = [
  {
    action: 'StartVoiceChat',
    apiPath: '/proxy',
    method: 'post',
  },
  {
    action: 'StopVoiceChat',
    apiPath: '/proxy',
    method: 'post',
  },
  {
    action: 'UpdateVoiceChat',
    apiPath: '/proxy',
    method: 'post',
  },
] as const;

/**
 * @brief 本地 Node Server 上跑的多 provider LLM 聊天接口（Vercel AI SDK）
 */
export const LlmAPIs = [
  {
    action: 'chat',
    apiPath: '/llm/chat',
    method: 'post',
  },
] as const;
